import {TemplateStructure} from '../types/templateStructure';
import {convertVariableSpansToText} from './variableUtils';
import {getTextContent, isContentEmpty} from './domUtils';

/**
 * Calculate the total character count across all template items
 * @param structure - The template structure to analyze
 * @returns Total character count
 */
export const calculateTotalCharacters = (structure: TemplateStructure): number => {
    let total = 0;
    
    structure?.forEach(item => {
        if(item.type === 'inline') {
            // Count template text
            const templateText = item?.value?.replace(/\{\{\d+\}\}/g, '');
            total += templateText.length;
            
            // Count all param values
            if(item.params) {
                item.params.forEach(param => {
                    if(param.value) {
                        const paramText = convertVariableSpansToText(param.value);
                        total += paramText.length;
                    }
                });
            }
        } else if(item.type === 'text') {
            const textContent = getTextContent(item.value);
            total += textContent.length;
        } else if(item.type === 'empty') {
            total += 2; // Count as line break
        }
    });
    
    return total;
};

/**
 * Get the count of filled (non-empty) template items
 * @param structure - The template structure to analyze
 * @returns Count of filled items
 */
export const getFilledItemsCount = (structure: TemplateStructure): number => {
    return structure.filter(item => {
        if(item.type === 'text') {
            return !isContentEmpty(item.value);
        }
        if(item.type === 'inline' && item.params && item.params.length > 0) {
            return item.params.some(p => p.value?.trim() !== '');
        }
        return false;
    }).length;
};

/**
 * Get the total count of editable template items
 * @param structure - The template structure to analyze
 * @returns Count of editable items
 */
export const getTotalEditableItemsCount = (structure: TemplateStructure): number => {
    return structure.filter(item => {
        if(item.type === 'text') return true;
        if(item.type === 'inline') return item.params && item.params.length > 0;
        return false;
    }).length;
};
